export default function DataTable({ columns, data, emptyMessage = 'No data available' }) {
  if (!data || data.length === 0) {
    return (
      <div className="rounded-2xl border border-surface-600 bg-surface-800 p-12 text-center text-slate-500">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-2xl border border-surface-600 bg-surface-800">
      <table className="w-full min-w-[700px] text-left text-sm">
        <thead>
          <tr className="border-b border-surface-600 bg-surface-700/50">
            {columns.map((col) => (
              <th
                key={col.key}
                className="px-4 py-3.5 text-xs font-semibold uppercase tracking-wider text-neon-cyan/70"
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr
              key={idx}
              className="border-b border-surface-700 last:border-0 transition-colors hover:bg-neon-cyan/[0.03]"
            >
              {columns.map((col) => (
                <td key={col.key} className="px-4 py-3 text-slate-300">
                  {col.render ? col.render(row[col.key], row) : row[col.key] ?? '--'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
